import { Layout, LayoutBehavior } from "@mcleod/components";
import { AppStickyManager } from "../sticky/AppStickyManager";

export class AppLayoutBehavior extends LayoutBehavior {
    protected constructor() {
        super();
    }

    public override setDeviceBehaviors(layout: Layout): void {
        super.setDeviceBehaviors(layout);

        if (!layout.isNested && layout._designer == null) {
            AppStickyManager.manageLayout(layout);
        }
    }
}

AppLayoutBehavior.register();
